import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
let lng = localStorage.getItem('i18nextLng');
if (lng === null)
    lng = "ko";
if (lng === "kr")
    lng = "ko";
console.log('i18next.js start', process.env.LANGUAGE_PATH);
i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    lng,
    fallbackLng: "en",
    //debug: true,
    interpolation: {
        escapeValue: false
    },
    backend: {
        loadPath: `${process.env.LANGUAGE_PATH}/{{lng}}/translation.json`,
        crossDomain: true,
        withCredentials: true,
        requestOptions: {
            cache: 'default',
            mode: 'cors',
        },
    },
});
/*
db
*/
setTimeout(() => {
    if (lng === "ko")
        localStorage.setItem('i18nextLng', 'kr');
}, 0);
export default i18n;
